import React, { FC, useEffect, useState } from "react";
import './ProgressBar.scss';

export interface ProgressBarProps {
	className?: string;
	done?: string;
};

const ProgressBar: FC<ProgressBarProps> = ({ className = "", done = "" }) => {

	const [style, setStyle] = useState({});

	useEffect(() => {
		const timer = window.setTimeout(() => {
			setStyle({
				opacity: 1,
				width: `${done}%`
			});
		}, 1100);
		return () => window.clearTimeout(timer);
	}, [done]);

	return (
		<div className={`progress`}>
			<div
				className="progressDone"
				style={style}
			>
				{done}%
			</div>
		</div>
	)
}

export default ProgressBar;